/**
 * Shared copy for the BETA chip + explainer panel (web + mobile).
 * UI components pass `featureName` and/or override `title` / `description`.
 */

/** Default panel heading above the body paragraph */
export const DEFAULT_BETA_PANEL_TITLE = "Beta feature";

/** Body when no feature name is provided */
export const GENERIC_BETA_ROLLOUT_DESCRIPTION =
  "This feature is in beta during rollout. Expect small UI changes and occasional gaps while we keep improving the experience.";

/** Body template when the area has a product name (e.g. "Trends", "Reports") */
export function betaRolloutDescription(featureName: string): string {
  return `${featureName} is in beta during rollout. Expect small UI changes and occasional gaps while we keep improving the experience.`;
}
